import type { FaireProductEntity } from "../../entity_types/product";

export const p_ut4y2ckn4j: FaireProductEntity = {
  token: "p_ut4y2ckn4j",
  type: "product",
  name: "Small Raw Amethyst Standing Cathedral, Ethically Sourced Crystals",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/621368af77024de28da4d7115fe00191bbcf7863630fd84f2ed7baed574fe912.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/983eb2a3aa5f705221c5afd0287f7c93165e842b6571d98edcbab0c1ccc4fa8b.jpeg",
    "https://cdn.faire.com/fastly/84327d4650af22c08d720940ce9acbaa7bdd53716c36257fb7b79441bd73a27c.jpeg",
    "https://cdn.faire.com/fastly/f09a632e8155424ceb06b231d42b61712b6ba5010d6e9610f2142c18c0f7ed1b.jpeg",
    "https://cdn.faire.com/fastly/80ffd28addc817ae62951d613ef60d08de67c17a4ccb628d352b3a1f77f73900.jpeg",
    "https://cdn.faire.com/fastly/2fec6d8c7dc1edce4b0c46451a7988d97bd0b62b53bccdc072c730e1696e4bed.jpeg",
    "https://cdn.faire.com/fastly/0e4e8b50a5ad64521e1c3350c09e7f50e792187c69c2cbd038a871b93c9d839a.jpeg",
    "https://cdn.faire.com/fastly/ee86262b82d9e622ab734e6efede7fc1d25b37b65c01d6dc93ad3910b3d2365b.jpeg",
  ],
  priceDollars: 14,
  description:
    "Small Raw Amethyst Cathedrals – Purple Uruguay Amethyst Geodes\n\nThese miniature amethyst cathedrals are natural geodes formed inside volcanic rock and lined with dense, sparkling crystal points. Sourced from Uruguay, they are prized for their purple color and fine crystal structure, even at smaller sizes.\n\nThe rough outer shell contrasts beautifully with the glittering interior, creating a tiny “crystal cave” effect that customers instantly understand and gravitate toward.\n\nRetail appeal:\n• High color in a compact, affordable size\n• Easy gift item with strong visual impact\n• Popular for desks, nightstands, and small spaces\n• Reliable seller in both mineral and metaphysical shops\n\nGreat for:\n– Crystal and rock shops\n– Gift and curiosity stores\n– Meditation and wellness boutiques\n– Checkout displays and starter collections\n\nBecause each formed in a natural gas pocket, every cathedral has its own shape and interior landscape. No two are alike.\n\nA classic crystal piece that feels substantial while remaining accessible and giftable.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:26.842Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
